export default __webpack_public_path__ + "static/media/chess-clock(reduced).9c537ee1.webp";